import React, { Component } from "react";
import MaterialTable, { MTableCell } from "material-table";
import {
    tsToDate, formatDateTime, getEventsArrayByDate
} from "../components/Utilities/DateTimeUtils";
import { handleError, pageLoaded } from "../components/Utilities/OtherUtils";
import { getColumns } from "../components/FeedbackComps/DebateResultsColumns";
import { get_motions, get_user_debate_results } from "../Backend/userBackendFunctions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { NewDebateResultForm } from "../components/DebateResults/NewDebateResultForm";
import Button from "@material-ui/core/Button";
import { add_custom_result } from "../Backend/feedbackBackendFunctions";
import { FormControlLabel, TextField } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";

/**
 * This page allows admins to view and analyze personal information and performance of the entire club's users
 * Consisted of three main components:
 * * Title: A toolbar with filters and actions
 * * Columns: Two arrays - one with personal info columns (email, phone number etc.) and one with
 *            a column per event (excluding lessons)
 * * Table Data: An array of rows. 3 Rows per User X Event.
 *               First row (score) is always visible, other two are expandable (chair+feedback and position)
 *
 * The table is based on material-table open source project: https://material-table.com/#/
 */
export class DebateResultsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            openDialog: false,
            hideEventsWithoutMotion: true,
            motionSearch: "",
            columns: []
        };
        this.refresh = this.refresh.bind(this);
        this.closeAddResultDialog = this.closeAddResultDialog.bind(this);
        this.openAddResultDialog = this.openAddResultDialog.bind(this);
        this.renderData = this.renderData.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.handleSearchMotionChange = this.handleSearchMotionChange.bind(this);
        this.addCustomResult = this.addCustomResult.bind(this);
    }

    openAddResultDialog() {
        this.setState({ openDialog: true });
    }

    addCustomResult(result) {
        let chair = this.convertToRealUser(result.chair);
        let partner = this.convertToRealUser(result.partner);
        let json = {
            chair: chair.uid,
            chair_name_eng: chair.full_name_eng,
            chair_name_heb: chair.full_name_heb,
            info_slide: result.info_slide,
            motion: result.motion,
            partner: partner.uid,
            partner_name_eng: partner.full_name_eng,
            partner_name_heb: partner.full_name_heb,
            position: result.position.title,
            rank: parseInt(result.rank.rank),
            speaker_points: result.speaker_points,
            time: result.time
        };
        this.setState({ openDialog: false, loading: true });
        add_custom_result(json)
            .then(_ => {
                this.setState({ loading: false });
                window.location.href = '/results';
            })
            .catch(e => {
                handleError(e);
                this.setState({ loading: false })
            });
    }

    convertToRealUser(fakeUser) {
        if (fakeUser.hasOwnProperty('uid')) {
            return fakeUser;
        }
        return {
            uid: fakeUser.id || "",
            full_name_eng: fakeUser.full_name_eng || "",
            full_name_heb: fakeUser.full_name_eng || ""
        }
    }

    closeAddResultDialog() {
        this.setState({ openDialog: false });
    }

    componentDidMount() {
        if (pageLoaded("results")) {
            this.props.onLoad();
            this.refresh();
        }
    }

    refresh() {
        const debaterColumns = getColumns();
        get_motions()
            .then(motions => {
                get_user_debate_results()
                    .then(results => {
                        let tableRawData = this.convertData(motions, results)
                        let tableData = tableRawData.filter(x => x.motion)
                        this.setState(
                            {
                                loading: false,
                                tableRawData,
                                tableData,
                                columns: debaterColumns
                            }
                        );
                    });
            })

    }

    convertData(motions, results) {
        let combinedList = {}
        for (let motionEntry in motions) {
            combinedList[motionEntry] = motions[motionEntry]
            if (results[motionEntry]) {
                combinedList[motionEntry] = { ...combinedList[motionEntry], ...results[motionEntry] }
            }
        }
        for (let resultEntry in results) {
            if (!combinedList[resultEntry]) {
                combinedList[resultEntry] = results[resultEntry]
            }
        }
        return Object
            .entries(combinedList)
            .map(entry => ({ id: entry[0], ...entry[1] }))
            .sort((a, b) => b.time.seconds - a.time.seconds)
            .map(entry => {
                entry.time = formatDateTime(tsToDate(entry.time));
                entry.rank = this.convertRank(entry);
                entry.speaker_points = this.convertSpeakerPoints(entry);
                return entry;
            })
    }

    convertSpeakerPoints(entry) {
        let speakerPoints = entry.speaker_points
        return (!speakerPoints || speakerPoints === 0) ? "" : speakerPoints
    }

    convertRank(entry) {
        switch (entry.rank) {
            case 1:
                return "1st";
            case 2:
                return "2nd";
            case 3:
                return "3rd";
            case 4:
                return "4th";
            default:
                return "";
        }
    }
    renderData() {
        if (!this.state.tableData) return []
        return this.state.hideEventsWithoutMotion ? this.state.tableData.filter(x => x.motion) : this.state.tableData
    }

    handleToggleChange() {
        let hideEventsWithoutMotion = !this.state.hideEventsWithoutMotion
        let tableData = hideEventsWithoutMotion ? this.state.tableRawData.filter(x => x.motion) : this.state.tableRawData
        let phrase = this.state.motionSearch
        tableData = tableData.filter(x => !phrase || x.motion.toLowerCase().includes(phrase.toLowerCase()) || x.info_slide.toLowerCase().includes(phrase.toLowerCase()))
        this.setState({ hideEventsWithoutMotion, tableData })
    }

    handleSearchMotionChange(e) {
        let phrase = e.target.value
        let tableData = this.state.hideEventsWithoutMotion ? this.state.tableRawData.filter(x => x.motion) : this.state.tableRawData
        tableData = tableData.filter(x => !phrase || x.motion.toLowerCase().includes(phrase.toLowerCase()) || x.info_slide.toLowerCase().includes(phrase.toLowerCase()))
        this.setState({ tableData, motionSearch: phrase })
    }

    render() {
        return (
            <div style={{ marginLeft: "5%", marginRight: "5%", marginTop: "5%" }}>

                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/icon?family=Material+Icons"
                />

                {/*This is really weird, but DO NOT REMOVE THIS <br/>*/}
                <br />

                <FormControlLabel
                    label="הציגו אימונים עם מושנים בלבד"
                    control={
                        <Checkbox
                            checked={this.state.hideEventsWithoutMotion}
                            onChange={this.handleToggleChange}
                        />
                    }
                />
                <br />
                <TextField style={{ marginBottom: "10px" }} id="outlined-basic" label="חיפוש מושנים" variant="outlined" onChange={this.handleSearchMotionChange} />

                <Dialog
                    open={this.state.openDialog}
                    onClose={this.closeAddResultDialog}>
                    <DialogContent>
                        <NewDebateResultForm
                            onClose={() => this.closeAddResultDialog()}
                            onSubmit={result => this.addCustomResult(result)}
                        />
                    </DialogContent>
                </Dialog>


                <MaterialTable
                    components={{
                        Cell: props => {
                            return <MTableCell {...props} />;
                        }
                    }}
                    icons={{ SortArrow: () => <span /> }}

                    isLoading={this.state.loading}
                    columns={this.state.columns}
                    data={this.renderData()}
                    title="Debate Results"
                    options={{
                        search: false,
                        sorting: true,
                        filtering: false,
                        columnsButton: false,
                        exportButton: false, //TODO: My export function
                        doubleHorizontalScroll: true,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [],
                        pageSize: 300
                    }}
                />
                <Button onClick={() => this.openAddResultDialog()}
                    style={{ margin: 10 }}
                    variant="contained"
                    color="primary">
                    Add Entry
                </Button>
            </div>
        );
    }
}
